"use client";

import { useSyncExternalStore } from "react";

const CHANGE_EVENT = "vh-session-flag-change";

/** Subscribes to same-tab session flag changes. */
function subscribe(onStoreChange: () => void) {
  window.addEventListener(CHANGE_EVENT, onStoreChange);

  return () => window.removeEventListener(CHANGE_EVENT, onStoreChange);
}

/** Boolean flag stored in sessionStorage, shared by every subscriber in the tab. */
export function useSessionFlag(key: string) {
  const isSet = useSyncExternalStore(
    subscribe,
    () => sessionStorage.getItem(key) !== null,
    () => false
  );

  const set = () => {
    sessionStorage.setItem(key, "1");
    window.dispatchEvent(new Event(CHANGE_EVENT));
  };

  return [isSet, set] as const;
}
